import { useBillingServiceStore } from '@billing/AppProvider'
import Permission from '@billing/app/models/permission.enum'
import { Box, Button, Container, Stack } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header, NoListResult, PlusIcon } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useSnackbar } from 'notistack'
import { PackageCard } from '../components/packageCard/PackageCard'

export const PackagesContainer = observer(() => {
  const { t } = useTranslate()
  const { packageListUIStore, packageDialogUIStore, authStore } = useBillingServiceStore()
  const canEdit = authStore.hasPermission(Permission.WriteCommodities)

  const { closeSnackbar } = useSnackbar()

  const handleToggle = (id?: number) => {
    closeSnackbar()
    packageDialogUIStore.toggle(id)
  }

  return (
    <>
      <Header
        searchInputLabel={t('searchPackaging', 'Search by packaging')}
        displaySearchIcon
        enableSearchField
        searchFilter={packageListUIStore.searchPackage}
        onSearchFieldChange={value => packageListUIStore.setSearchPackage(value)}
        rightRenderOption={
          canEdit && (
            <Box flex='none'>
              <Button
                color='inherit'
                variant='contained'
                startIcon={<PlusIcon />}
                onClick={() => handleToggle()}
              >
                {t('addNew', 'Add new')}
              </Button>
            </Box>
          )
        }
      />

      <Container>
        <Stack gap={2} paddingY={2}>
          {packageListUIStore.packages.map(x => (
            <PackageCard
              key={x.id}
              packageItem={x}
              canEdit={canEdit}
              onClick={c => (canEdit ? handleToggle(c.id) : false)}
            />
          ))}
          {!packageListUIStore.packages.length && (
            <NoListResult
              result={t('noPackageFound', 'No package found')}
              filtering={!!packageListUIStore.searchPackage}
              onClearFilter={() => packageListUIStore.setSearchPackage('')}
            />
          )}
        </Stack>
      </Container>
    </>
  )
})
